export interface CommentsSectionVisibilityArgs {
  enablePublicComments?: string;
  isIdentifiedUser: boolean;
  commentCount: number;
}

/**
 * Mirrors the server's rule for `flowConfig.enablePublicComments`
 * (getSharedMessagesForTicket): with "nobody" the API strips user comments from
 * a feature request and returns team updates only, with "identified" they are
 * reserved for logged-in users. Anything else (including an unset value) means
 * everyone sees them.
 */
export const isPublicCommentViewingEnabled = (
  enablePublicComments: string | undefined,
  isIdentifiedUser: boolean,
): boolean => {
  if (enablePublicComments === "nobody") {
    return false;
  }
  if (enablePublicComments === "identified") {
    return isIdentifiedUser;
  }
  return true;
};

/**
 * Whether the feature request details view should render its comments section.
 *
 * With viewing switched off the list can only ever hold team updates, so an
 * empty list means there is genuinely nothing to show — the section, its
 * divider and its "no comments yet" placeholder are dropped entirely rather
 * than left behind as an empty block. While viewing is on the placeholder
 * stays: that list is only one submission away from having content.
 */
export const shouldShowCommentsSection = ({
  enablePublicComments,
  isIdentifiedUser,
  commentCount,
}: CommentsSectionVisibilityArgs): boolean => {
  if (commentCount > 0) {
    return true;
  }
  return isPublicCommentViewingEnabled(enablePublicComments, isIdentifiedUser);
};
